import * as z from "zod"

export const FormSchemaVideoGameGenerator = z.object({
  buchstabe: z.enum(
    [
      "random",
      "a",
      "b",
      "c",
      "d",
      "e",
      "f",
      "g",
      "h",
      "i",
      "j",
      "k",
      "l",
      "m",
      "n",
      "o",
      "p",
      "q",
      "r",
      "s",
      "t",
      "u",
      "v",
      "w",
      "x",
      "y",
      "z",
    ],
    {
      required_error: "Please select a letter or random",
    }
  ),
  sprache: z.enum(
    [
      "german",
      "english",
      "french",
      "spanish",
      "italian",
      "russian",
      "japanese",
      "chinese",
      "korean",
    ],
    {
      required_error: "Please select a language",
    }
  ),

  geschlecht: z.enum(["masculine", "feminine"]).optional(),

  klang: z.enum(["gamer", "leet", "epic", "cute", "cool", "funny"], {
    required_error: "Please select a sound",
  }),
  silben: z.enum(["one", "two", "three", "four+"]).optional(),
})

export type FormValuesVideoGame = z.infer<typeof FormSchemaVideoGameGenerator>

export type KlangOption = {
  value: FormValuesVideoGame["klang"]
  label: string
  icon: string
}

export type SilbenOption = {
  value: FormValuesVideoGame["silben"]
  label: string
  icon: string
}

export type SprachOption = {
  value: FormValuesVideoGame["sprache"]
  label: string
  icon: string
}

export type GeschlechtOption = {
  value: FormValuesVideoGame["geschlecht"]
  label: string
  icon: string
}

export type Buchstabe = FormValuesVideoGame["buchstabe"]